// Group by options
export const GROUP_BY_OPTIONS = [
  {
    id: 'action_performed_by_user',
    label: 'User',
    key: 'user',
  },
  {
    id: 'action_performed_by_user_role',
    label: 'Job role',
    key: 'job_role',
  },
];

// Breakdown options
export const BREAKDOWN_OPTIONS = [
  { id: null, label: 'None' },
  { id: 'job_name', label: 'Job name' },
  { id: 'action_performed_by_user', label: 'User' },
  { id: 'appl_source', label: 'Source (on application)' },
  { id: 'department', label: 'Department' },
  { id: 'office', label: 'Office' },
];

// Define metric definitions for each column
export const metricDefinitions: Record<string, string> = {
  'Sourced applications': 'Number of applicants added to a job',
  'Screened applications':
    'Number of applicants screened from the application review stage',
  'Interviews scheduled': 'Number of interviews scheduled',
  'Interview reschedules': 'Number of reschedules done for interviews',
  'Interviews conducted': 'Interviews where the user was an interviewer',
  'Interviews canceled':
    'Number of interviews canceled by a particular user/role',
  'Offers sent': 'Number of offers sent',
  'Offer revisions done': 'Number of offer revisions done',
  Hired: 'Number of applicants hired',
  Rejected: 'Number of applicants rejected',
  'Avg. time to offer': 'Average time taken from application to offer',
  'Offer acceptance rate': 'Percentage of offers accepted',
  'Avg. time to hire': 'Average time taken from application to hire',
};

// Define based on values for each column
export const basedOnValues: Record<string, string> = {
  'Sourced applications': 'Application creation date',
  'Screened applications': 'Stage movement date',
  'Interviews scheduled': 'Interview scheduled date',
  'Interview reschedules': 'Interview reschedule date',
  'Interviews conducted': 'Interview conducted date',
  'Interviews canceled': 'Interview canceled date',
  'Offers sent': 'Offer sent date',
  'Offer revisions done': 'Offer revision date',
  Hired: 'Hired date',
  Rejected: 'Rejection date',
  'Avg. time to offer': 'Offer sent date',
  'Offer acceptance rate': 'Offer acceptance date',
  'Avg. time to hire': 'Hired date',
};
